import { useAppSelector } from "@store";
import { isEntityActive } from "@store/story/selectors";
import { useEffect, useRef, useState } from "react";

export const useOnDragEnd = ({ id }: { id: string }) => {
  const [dragKey, setDragKey] = useState(0);
  const wasDragging = useRef(false);
  const isDragging = useAppSelector((state) => {
    const isActive = isEntityActive(id)(state);
    if (!isActive) return false;
    return state.story.isDragging;
  });

  useEffect(() => {
    if (isDragging) {
      wasDragging.current = true;
      return;
    }
    if (!wasDragging.current) return;
    const timeoutId = setTimeout(() => {
      setDragKey((prevKey) => prevKey + 1);
    }, 350);
    return () => clearTimeout(timeoutId);
  }, [isDragging]);

  return dragKey;
};
